const isTabKey = function (e) {
    return e.key === 'Tab';
};
export default isTabKey;
